<script setup lang="ts">
import { ref, onMounted } from 'vue'

/**
 * Variáveis reativas substituindo as Expressões JSF (EL)
 * #{mbConfiguracaoUsuario.theme} e #{confPadrao.tituloPagina}
 */
const themeColor = ref<string>('#ffffff') // Valor padrão, idealmente viria de uma store (ex: Pinia)
const pageTitle = ref<string>('Título da Página')

onMounted(() => {
  // TODO: Caso os valores de tema e título venham de uma API específica da sessão do usuário,
  // a chamada deve ser feita aqui ou globalmente na inicialização da aplicação.
})
</script>

<template>
  <!-- 
    No Vue 3, a manipulação do <head> a partir de um componente interno 
    pode ser feita nativamente utilizando o <Teleport to="head">.
  -->
  <Teleport to="head">
    <meta http-equiv="X-UA-Compatible" content="IE=edge" />
    <meta http-equiv="Content-Type" content="text/html; charset=UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0" />
    <meta name="apple-mobile-web-app-capable" content="yes" />
    
    <!-- #{mbConfiguracaoUsuario.theme} -->
    <meta name="theme-color" :content="themeColor" />
    
    <meta name="author" content="Akio Tiago Chiuji, Anderson Friaça, Carlos Cesar Dias dos Santos, Israel Alencar França, Wilds Ovando Pereira Filho" />
    
    <!-- #{confPadrao.tituloPagina} -->
    <title>{{ pageTitle }}</title>

    <!-- 
      ATENÇÃO - MIGRAÇÃO DE SCRIPTS LEGADOS:
      Os scripts abaixo foram intencionalmente removidos pois o PrimeVue + Vue 3 gerenciam essas funcionalidades nativamente:
      - nanoscroller.js / layout.js / swipe.js: Obsoletos, o layout moderno usa CSS Flex/Grid.
      - ripple.js: O PrimeVue possui a diretiva v-ripple nativa.
      - locale-primefaces-pt_BR.js: portado para src/plugins/primevue-locale.ts e aplicado no
        main.ts via app.use(PrimeVue, { locale: localePtBr }).
    -->

    <!-- <ui:insert name="head"/> -->
    <slot name="head"></slot>
  </Teleport>
</template>

<style scoped>
/* Estilos globais relacionados ao head não são aplicáveis aqui, estilos do layout devem ir para o CSS global da aplicação */
</style>